export default __webpack_public_path__ + "static/898-c9607a786e1ee5b2148ed2a8c8a35f58.gif";